(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_flexi-layout-card-slider"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const roots = document.querySelectorAll('[data-flexi-card-slider]');
  
    const getBreakpoint = () => {
      const w = window.innerWidth;
      if (w <= 500) return 'mobile';
      if (w <= 900) return 'tablet';
      return 'desktop';
    };
  
    const revealPagination = (sliderEl) => {
      const el = sliderEl?.querySelector('.blaze-pagination');
      if (!el) return;
      el.classList.remove('u-opacity-0');
      el.classList.add('u-opacity-100');
    };

    const syncCardHeights = (root) => {
      root.style.removeProperty('--flexi-card-min-height');
      const cards = root.querySelectorAll('.flexi-group-wrapper');
      if (!cards.length) return;
      const max = Math.max(...[...cards].map(c => c.offsetHeight));
      if (max > 0) root.style.setProperty('--flexi-card-min-height', max + 'px');
    };
  
    const getConfig = (sliderEl) => {
      const desktopSlides = parseFloat(sliderEl.dataset.blazeDesktop) || 4;
      const tabletSlides = parseFloat(sliderEl.dataset.blazeTablet) || 2.2;
      const mobileSlides = parseFloat(sliderEl.dataset.blazeMobile) || 1.2;
      const loop = sliderEl.dataset.blazeLoop === 'true';
      const draggable = sliderEl.dataset.blazeDraggable === 'true';
      const autoplay = sliderEl.dataset.blazeAutoplay === 'true';
      const autoplayDuration = parseFloat(sliderEl.dataset.blazeAutoplayDuration) || 2000;
      const autoplayPause = sliderEl.dataset.blazeAutoplayPause === 'true';
      const paginationStyle = sliderEl.dataset.blazePaginationStyle || 'dots';

      return {
        all: {
          slidesToShow: desktopSlides,
          slidesToScroll: 1,
          transitionDuration: 200,
          loop,
          draggable,
          autoplayInterval: autoplayDuration,
          enableAutoplay: autoplay,
          stopAutoplayOnInteraction: autoplayPause,
          enablePagination: paginationStyle === 'dots',
        },
        '(max-width: 900px)': {
          slidesToShow: tabletSlides,
        },
        '(max-width: 500px)': {
          slidesToShow: mobileSlides,
        },
      };
    };
  
    const destroySlider = (sliderEl) => {
      if (!sliderEl) return;

      sliderEl._flexiScrollbarCleanup?.();
      delete sliderEl._flexiScrollbarCleanup;
      const obs = sliderEl._flexiScrollbarObserver;
      if (obs) {
        obs.disconnect();
        delete sliderEl._flexiScrollbarObserver;
      }

      const instance = sliderEl.blazeSlider;
      if (instance?.destroy) instance.destroy();

      const paginationEl = sliderEl.querySelector('.blaze-pagination');
      if (paginationEl) paginationEl.innerHTML = '';

      sliderEl.blazeSlider = null;
    };
  
    const setupScrollbarPagination = (sliderEl, slider) => {
      const paginationEl = sliderEl.querySelector('.blaze-pagination--scrollbar');
      if (!paginationEl || !slider) return;

      const trackEl = paginationEl.querySelector('.blaze-scrollbar-track');
      const fillEl = paginationEl.querySelector('.blaze-scrollbar-fill');
      const blazeTrack = sliderEl.querySelector('.blaze-track');
      if (!trackEl || !fillEl || !blazeTrack) return;

      let hideTimer = null;
      const showScrollbar = () => {
        paginationEl.classList.add('blaze-scrollbar-visible');
        if (hideTimer) clearTimeout(hideTimer);
        hideTimer = setTimeout(() => {
          paginationEl.classList.remove('blaze-scrollbar-visible');
          hideTimer = null;
        }, 1000);
      };

      const updateScrollbar = (percent) => {
        fillEl.style.width = Math.max(0, Math.min(100, percent)) + '%';
      };

      const updateFromState = () => {
        const numStates = slider.states?.length || 1;
        paginationEl.style.display = numStates <= 1 ? 'none' : '';
        if (numStates <= 1) return;
        const idx = slider.stateIndex ?? 0;
        updateScrollbar((idx / (numStates - 1)) * 100);
      };

      slider.onSlide(updateFromState);
      updateFromState();

      const container = sliderEl.querySelector('.blaze-container');
      if (container) {
        container.addEventListener('pointerdown', showScrollbar);
        container.addEventListener('touchstart', showScrollbar);
      }

      trackEl.addEventListener('click', (e) => {
        const rect = trackEl.getBoundingClientRect();
        const percent = ((e.clientX - rect.left) / rect.width) * 100;
        const numStates = slider.states?.length || 1;
        if (numStates <= 1) return;
        const targetIdx = Math.round((percent / 100) * (numStates - 1));
        const steps = targetIdx - (slider.stateIndex ?? 0);
        if (steps > 0) slider.next(steps);
        else if (steps < 0) slider.prev(-steps);
      });

      const obs = new MutationObserver(() => {
        showScrollbar();
        requestAnimationFrame(() => {
          const wrapper = blazeTrack.closest('.blaze-track-wrapper') || blazeTrack.parentElement;
          if (!wrapper) return;
          const wr = wrapper.getBoundingClientRect();
          const tr = blazeTrack.getBoundingClientRect();
          const maxScroll = Math.max(0, tr.width - wr.width);
          if (maxScroll <= 0) return;
          updateScrollbar((Math.max(0, Math.min(1, (wr.left - tr.left) / maxScroll))) * 100);
        });
      });
      obs.observe(blazeTrack, { attributes: true, attributeFilter: ['style'] });
      sliderEl._flexiScrollbarObserver = obs;
      sliderEl._flexiScrollbarCleanup = () => {
        if (hideTimer) clearTimeout(hideTimer);
        container?.removeEventListener('pointerdown', showScrollbar);
        container?.removeEventListener('touchstart', showScrollbar);
      };
    };

    const createSlider = (sliderEl) => {
      if (!sliderEl || sliderEl.blazeSlider) return sliderEl?.blazeSlider || null;

      const slider = new BlazeSlider(sliderEl, getConfig(sliderEl));
      const paginationStyle = sliderEl.dataset.blazePaginationStyle || 'dots';

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          slider.refresh();
          revealPagination(sliderEl);
          if (paginationStyle === 'scrollbar') {
            setupScrollbarPagination(sliderEl, slider);
          }
          const root = sliderEl.closest('[data-flexi-card-slider]');
          if (root) syncCardHeights(root);
        });
      });

      return slider;
    }; 
  
    const reinitRootSlider = (root) => {
      const sliderEl = root.querySelector('.blaze-slider');
      if (!sliderEl) return;
  
      destroySlider(sliderEl);
      createSlider(sliderEl);
    };
  
    const refreshRootSlider = (root) => {
      reinitRootSlider(root);
    };
  
    roots.forEach((root) => {
      let currentBp = getBreakpoint();

      let _syncTimer = null;
      new ResizeObserver(() => {
        clearTimeout(_syncTimer);
        _syncTimer = setTimeout(() => syncCardHeights(root), 200);
      }).observe(root);
  
      window.addEventListener('load', () => {
        reinitRootSlider(root);
      });
  
      window.addEventListener('resize', () => {
        clearTimeout(root._flexiResizeTimer);
        root._flexiResizeTimer = setTimeout(() => {
          const newBp = getBreakpoint();
  
          if (newBp !== currentBp) {
            currentBp = newBp;
            refreshRootSlider(root);
          } else {
            const sliderEl = root.querySelector('.blaze-slider');
            const blaze = sliderEl?._flexiBlaze ?? sliderEl?.blazeSlider;
            blaze?.refresh();
            requestAnimationFrame(() => syncCardHeights(root));
          }
        }, 150);
      });
    });
  
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-flexi-card-slider]').forEach((root) => {
        reinitRootSlider(root);
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["flexi-block-accordion"] && !Shopify.designMode) return;
  try {
    (() => {
    const initAccordions = (scope = document) => {
      scope.querySelectorAll('.flexi-accordion-block').forEach((root) => {
        root.querySelectorAll('[data-flexi-accordion-item]').forEach((item) => {
          const trigger = item.querySelector('[data-flexi-accordion-trigger]');
          const panel = item.querySelector('[data-flexi-accordion-panel]');
          const icon = trigger ? trigger.querySelector('.flexi-rotate-icon') : null;

          if (!trigger || !panel || trigger.dataset.flexiAccordionBound === 'true') return;
          trigger.dataset.flexiAccordionBound = 'true';

          trigger.addEventListener('click', () => {
            const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
            const nextExpanded = !isExpanded;

            trigger.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
            panel.classList.toggle('is-open', nextExpanded);
            panel.setAttribute('aria-hidden', nextExpanded ? 'false' : 'true');

            if (icon) {
              icon.classList.toggle('flexi-rotate-icon--active', nextExpanded);
            }
          });
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAccordions());
    } else {
      initAccordions();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initAccordions(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["flexi-block-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    let openOverlay = null;
    let lastTrigger = null;

    const lockScroll = () => {
      document.body.style.overflow = 'hidden';
    };

    const unlockScroll = () => {
      if (!document.querySelector('.flexi-popup-overlay.is-open')) {
        document.body.style.overflow = '';
      }
    };

    const closeOverlay = (overlay) => {
      if (!overlay) return;

      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');

      if (openOverlay === overlay) {
        openOverlay = null;
      }

      unlockScroll();

      if (lastTrigger) {
        lastTrigger.focus();
        lastTrigger = null;
      }
    };

    const openOverlayEl = (overlay, trigger) => {
      if (!overlay) return;

      if (openOverlay && openOverlay !== overlay) {
        closeOverlay(openOverlay);
      }

      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      openOverlay = overlay;
      lastTrigger = trigger || null;
      lockScroll();

      const closeBtn = overlay.querySelector('[data-flexi-popup-close]');
      if (closeBtn) closeBtn.focus();
    };

    const removeOverlayByTrigger = (root) => {
      const trigger = root.querySelector('[data-flexi-popup-open]');
      const overlayId = trigger?.getAttribute('aria-controls');
      if (!overlayId) return;

      const overlay = document.getElementById(overlayId);
      if (!overlay) return;

      if (openOverlay === overlay) closeOverlay(overlay);
      overlay.remove();
    };

    const initPopups = (scope = document) => {
      scope.querySelectorAll('[data-flexi-popup]').forEach((root) => {
        if (root.dataset.flexiPopupBound === 'true') return;

        const trigger = root.querySelector('[data-flexi-popup-open]');
        const overlay = root.querySelector('[data-flexi-popup-overlay]');
        if (!trigger || !overlay) return;

        root.dataset.flexiPopupBound = 'true';

        const existing = document.getElementById(overlay.id);
        if (existing && existing !== overlay) {
          if (openOverlay === existing) closeOverlay(existing);
          existing.remove();
        }

        if (overlay.parentElement !== document.body) {
          document.body.appendChild(overlay);
        }

        trigger.addEventListener('click', () => {
          openOverlayEl(overlay, trigger);
        });

        overlay.addEventListener('click', (event) => {
          if (event.target === overlay) {
            closeOverlay(overlay);
          }
        });

        overlay.querySelectorAll('[data-flexi-popup-close]').forEach((btn) => {
          btn.addEventListener('click', () => closeOverlay(overlay));
        });
      });
    };

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && openOverlay) {
        closeOverlay(openOverlay);
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initPopups());
    } else {
      initPopups();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initPopups(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-flexi-popup]').forEach(removeOverlayByTrigger);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["flexi-block-tabs"] && !Shopify.designMode) return;
  try {
    (() => {
    const selectTab = (root, nextTab) => {
      const tabs = [...root.querySelectorAll('[data-flexi-tab]')];
      const panels = [...root.querySelectorAll('[data-flexi-tabpanel]')];

      tabs.forEach((tab) => {
        const isSelected = tab.dataset.flexiTab === nextTab;
        tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        tab.setAttribute('tabindex', isSelected ? '0' : '-1');
        tab.classList.toggle('active', isSelected);
        tab.classList.toggle('not-active', !isSelected);
        if (isSelected) tab.focus();
      });

      panels.forEach((panel) => {
        panel.hidden = panel.dataset.flexiTabpanel !== nextTab;
      });
    };

    const initTabs = (scope = document) => {
      scope.querySelectorAll('[data-flexi-tabs]').forEach((root) => {
        if (root.dataset.flexiTabsBound === 'true') return;
        root.dataset.flexiTabsBound = 'true';

        const tablist = root.querySelector('[data-flexi-tablist]');
        const tabs = [...root.querySelectorAll('[data-flexi-tab]')];
        if (!tablist || !tabs.length) return;

        tabs.forEach((tab) => {
          tab.addEventListener('click', () => {
            selectTab(root, tab.dataset.flexiTab);
          });
        });

        tablist.addEventListener('keydown', (event) => {
          const currentIndex = tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
          if (currentIndex < 0) return;

          let nextIndex = currentIndex;
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            nextIndex = (currentIndex + 1) % tabs.length;
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
          } else {
            return;
          }

          selectTab(root, tabs[nextIndex].dataset.flexiTab);
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initTabs());
    } else {
      initTabs();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initTabs(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
